import { CheckIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { Delegator } from "types";
import { SellerLogo } from "@/components/Common/SellerLogo";
import { getAddress } from "@/models/Seller";

interface DelegatorTileProps {
    delegator: Delegator;
    isActive?: boolean;
    onClick: () => void;
}

export const DelegatorTile = ({ delegator, isActive = false, onClick }: DelegatorTileProps) => {
    const address = getAddress(delegator);

    return (
        <div
            className={clsx("flex cursor-pointer items-center space-x-4 p-3 hover:bg-gray-lighter", {
                "bg-gray-lighter": isActive,
            })}
            onClick={onClick}
        >
            <SellerLogo seller={delegator} />
            <div className="min-w-0 flex-1">
                <p className="no-translate truncate text-black">{delegator.name}</p>
                {address ? <p className="no-translate truncate text-sm text-gray-dark">{address}</p> : null}
            </div>
            {isActive ? <CheckIcon className="shrink-0 text-green" /> : null}
        </div>
    );
};
